"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideTheHideOnBuyItems = exports.checkVisible = exports.consumeMaterialsFromRecipe = exports.consumeMaterials = exports.howManyRecipesCanBeMade = exports.checkAmounts = void 0;
const values_1 = __importDefault(require("./values"));
const lodash_1 = __importDefault(require("lodash"));
const smap_1 = require("./smap");
const bigmath_1 = require("./bigmath");
function checkAmounts(amounts, requirements) {
    return (0, smap_1.mapPairs)(requirements, (amt, key) => (amounts[key] ?? 0) >= amt).every((x) => x === true);
}
exports.checkAmounts = checkAmounts;
function howManyRecipesCanBeMade(itemName, amounts) {
    const recipe = values_1.default.recipes[itemName];
    if (recipe === undefined)
        return 0n;
    let numberOfRecipesToMake = bigmath_1.REALLY_BIG;
    const scale = values_1.default.calculateRecipeScale(itemName, amounts[itemName]);
    lodash_1.default.toPairs(recipe).forEach((pair) => {
        let [ingredientName, requiredCount] = pair;
        const totalRequired = (0, bigmath_1.bigMul)(requiredCount, scale);
        // const totalRequired = requiredCount * scale;
        const weHave = amounts[ingredientName] ?? 0;
        if (weHave < totalRequired) {
            numberOfRecipesToMake = 0n;
        }
        else {
            numberOfRecipesToMake = (0, bigmath_1.bigMin)((0, bigmath_1.bigDiv)(weHave, totalRequired), numberOfRecipesToMake);
        }
    });
    return (0, bigmath_1.bigFloor)(numberOfRecipesToMake);
}
exports.howManyRecipesCanBeMade = howManyRecipesCanBeMade;
function consumeMaterials(itemName, amountWeHave, recipe, recipeCount) {
    const scale = itemName
        ? values_1.default.calculateRecipeScale(itemName, amountWeHave[itemName])
        : recipeCount;
    lodash_1.default.toPairs(recipe).forEach((pair) => {
        let [ingredientName, requiredCount] = pair;
        const toGrab = (0, bigmath_1.bigMul)(requiredCount, scale);
        const weHave = amountWeHave[ingredientName] ?? 0n;
        amountWeHave[ingredientName] = (0, bigmath_1.bigMax)(0n, weHave - toGrab);
    });
}
exports.consumeMaterials = consumeMaterials;
function consumeMaterialsFromRecipe(itemName, amounts, recipeCount) {
    const recipe = values_1.default.recipes[itemName];
    if (recipe === undefined)
        return false;
    // not producing, so let's try to grab materials
    if (howManyRecipesCanBeMade(itemName, amounts) < recipeCount)
        return false;
    consumeMaterials(itemName, amounts, recipe, recipeCount);
    return true;
}
exports.consumeMaterialsFromRecipe = consumeMaterialsFromRecipe;
function checkVisible(state, dispatch) {
    const { visible, amountThatWeHave, } = state;
    let discoveredSomething = true;
    const itemsDiscovered = [];
    function _visible(itemName) {
        dispatch({ action: 'unhide-item', itemName: itemName });
        itemsDiscovered.push(itemName);
        discoveredSomething = true;
    }
    while (discoveredSomething) {
        discoveredSomething = false;
        values_1.default.allItemNames.forEach((itemName) => {
            if (visible[itemName] === undefined) {
                const unlockedWith = values_1.default.unlockedWith[itemName].every((x) => (amountThatWeHave[x] ?? 0) > 0);
                if (values_1.default.unlockedWith[itemName].length > 0 && unlockedWith) {
                    _visible(itemName);
                    return;
                }
                if (!unlockedWith) {
                    return;
                }
                const required = values_1.default.requiredBuildings(itemName);
                const haveBuilding = required.some((x) => visible[x]) ||
                    required.includes("by-hand");
                const recipe = values_1.default.recipes[itemName];
                const haveIngredients = (0, smap_1.keys)(recipe).every((key) => visible[key]);
                if (haveBuilding &&
                    unlockedWith &&
                    ((0, smap_1.keys)(recipe).length === 0 || haveIngredients)) {
                    _visible(itemName);
                    return;
                }
                if (values_1.default.makesAsASideProduct(itemName).some((x) => visible[x])) {
                    _visible(itemName);
                    return;
                }
            }
        });
    }
    return itemsDiscovered;
}
exports.checkVisible = checkVisible;
function hideTheHideOnBuyItems(state) {
    const { visible, amountThatWeHave, } = state;
    values_1.default.allItemNames.forEach((itemName) => {
        if (values_1.default.hideOnBuy(itemName) && (amountThatWeHave[itemName] ?? 0n) > 0) {
            visible[itemName] = false;
        }
    });
}
exports.hideTheHideOnBuyItems = hideTheHideOnBuyItems;
